import React from 'react';
import {
  ATMContainer,
  ATMHeader,
  IORGDataTableColumn,
  ORGDataTable,
} from 'shared-it-appmod-ui';
import Lang from 'src/libraries/language';
import { IFlightOperator } from 'src/models/flight-operator.model';
import style from './flight-operators-list.module.scss';
import FlightOperatorsAdd from '../flight-operators-add/flight-operators-add.component';
import FlightOperatorsEdit from '../flight-operators-edit/flight-operators-edit.component';
import FlightOperatorsDelete from '../flight-operators-delete/flight-operators-delete.component';

type IProp = {
  data: IFlightOperator[];
  loading: boolean;
};

const FlightOperatorsView: React.FC<IProp> = ({ data, loading }) => {
  const customColumns: IORGDataTableColumn<IFlightOperator>[] = [
    {
      title: Lang.LBL_OPERATOR_NAME,
      index: 'name',
      width: '20%',
    },
    {
      title: Lang.LBL_OPERATOR_EMAIL,
      index: 'email',
      width: '20%',
    },
    {
      title: Lang.LBL_ACTIVE,
      index: 'activeFlag',
      render: (_, value) => (
        <span>{value.activeFlag ? Lang.LBL_YES : Lang.LBL_NO}</span>
      ),
      width: '20%',
    },
    {
      title: Lang.LBL_DISPATCH,
      index: 'dispatchFlag',
      render: (_, value) => (
        <span>{value.dispatchFlag ? Lang.LBL_YES : Lang.LBL_NO}</span>
      ),
      width: '20%',
    },
    {
      title: Lang.LBL_ACTIONS,
      index: 'actions',
      render: (_, value) => (
        <>
          <FlightOperatorsEdit data={value} />
          <FlightOperatorsDelete data={value} />
        </>
      ),
      width: '20%',
    },
  ];

  // for UT Coverage
  if (process.env.REACT_APP_SWITCH_TO_UNIT_TEST_MODE === 'true') {
    if (customColumns[2].render) {
      customColumns[2].render(true, {} as IFlightOperator, 1, {} as any);
    }
    if (customColumns[3].render) {
      customColumns[3].render(true, {} as IFlightOperator, 1, {} as any);
    }
    if (customColumns[4].render) {
      customColumns[4].render(true, {} as IFlightOperator, 1, {} as any);
    }
  }

  return (
    <ATMContainer className={style.container}>
      <div className={style.header}>
        <ATMHeader as="h1" content={Lang.TTL_ADMIN_FLIGHT_OPERATORS} />
        <FlightOperatorsAdd />
      </div>
      <ORGDataTable
        celled={false}
        columns={customColumns}
        data={data}
        loading={loading}
      />
    </ATMContainer>
  );
};

export default FlightOperatorsView;
